<template>
	<ui-form :model="model" :transfer-model.sync="submitData" view v-slot="{data}">
		<ui-text v-model="data.count" label="姓名"/>
		<ui-text v-model="data.email" label="邮箱"/>
		<ui-text v-model="data.mobile" value-type="phone" label="联系电话"/>
		<ui-template v-if="params.type!='view'">
			<ui-button type="submit" @submit="submit"></ui-button>
			<ui-button type="reset" v-if="params.type=='add'"></ui-button>
		</ui-template>
	</ui-form>
</template>

<script>
export default {
	props:['params','close'],
	data(){
		return {
			model:{},
			submitData:{}
		};
	},
	mounted(){
		console.log(this.params)
		this.$axios.get('/admin/sys/info/'+this.params.data.id).then(data=>{
			console.log(data)
			this.model=data;
		}).end();
	},
	methods:{
		// submit(){
		// 	this.$axios.request({url:'/mydetail/'+this.params.data.id,data:this.submitData,method:'put',urlencode:true})
		// 	.then(data=>{
		// 		this.close();
		// 	}).end();
		// },
	},
}
</script>

<style>
</style>
